import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import ConfirmDialog from '../components/common/ConfirmDialog';
import User from '../models/User';

const defaultCriteria = {
  limit: 10,
  orderField: null,
  orderType: 'ASC',
  page: 0,
};

export default class PatientListBloc {
  patients$ = new BehaviorSubject([]);
  total$ = new BehaviorSubject(0);
  searchCriteria$ = new BehaviorSubject(defaultCriteria);

  constructor({ patientRepository, dialogRepository, drawerRepository, authRepository, userRepository }) {
    this.userRepository = userRepository;
    this.patientRepository = patientRepository;
    this.drawerRepository = drawerRepository;
    this.dialogRepository = dialogRepository;
    this.authRepository = authRepository;
    this.searchSubscription = this.searchCriteria$.subscribe(() => {
      this.getPatients();
    });
  }

  async getPatients() {
    const patients = await this.patientRepository.getPatients(this.searchCriteria$.getValue());
    patients.data = patients.data.map((item) => new User(item));
    this.patients$.next(patients.data);
    this.total$.next(patients.total);
  }

  updateSearchCriteria(updatedCriteria) {
    this.searchCriteria$.next({
      ...this.searchCriteria$.getValue(),
      ...updatedCriteria,
    });
  }

  resendInvite(component) {
    this.drawerRepository.loadDrawer(component);
  }

  get currentUser$() {
    return this.authRepository.auth$;
  }

  getWorkspaceId() {
    return this.authRepository.auth$.getValue().workspaceId;
  }

  get isMediphanyWorkspace$() {
    return this.authRepository.userWorkspace$.pipe(map((workspace) => workspace.isMediphanyWorkspace));
  }

  deleteUser(userId, message, refreshData, toastSuccess) {
    this.dialogRepository.loadDialog(ConfirmDialog, {
      cancelBtnAction: () => {
        this.dialogRepository.toggleDialog(false);
      },
      cancelBtnText: 'Cancel',
      message,
      okBtnAction: async () => {
        await this.userRepository.deleteUser(userId);
        this.dialogRepository.toggleDialog(false);
        toastSuccess();
        await refreshData();
      },
      okBtnText: 'Delete',
      title: '',
    });
  }
}
